<template>
    <div class="code-view">
        <el-input 
        class="code-input" 
        v-model="team" 
        placeholder="输入队伍码确认加入参赛战队" 
        ref="code_input"
        :readonly="next"
        ></el-input>
        
        <el-button class="u-btn join" v-if="next" @click="join_team">确认加入队伍</el-button>
        <el-button class="u-btn search" v-else @click="search_handle">搜索</el-button>
    </div>  
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        team : '',
        next : false,
        loading: false,
        tid : '',
      };
    },
    props : {
        ua : {
            default : ()=>{},
        }
    },
    watch: {
        dialogVisible (newVal) {
            if (newVal) {
                setTimeout(()=>{
                    this.$refs.code_input.focus();
                },10)
            }
            else{
                //TODO
                this.next = false;
                this.team = '';
            }
        }
    },    
    methods: {
      handleClose(done) {
          this.$destroy();
      },
      search_handle() {
          var self = this;
          //this.$emit('destory_all', ['inner_code']);
          //this.next = true;
          if(!this.team)return this.$message.error('请填写战队码');
          
          this.$axios.get(this.$ajax_url_map.code,{
              params : {
                  code : this.team,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success){
                  this.next = true;
                  this.team = res.data.data.name;
                  this.tid = res.data.data.id;
              }
              else{
                this.$message.error(res.data.message);  
              }
          })
      },
      join_team (){

          let self = this;

          this.$axios.get(this.$ajax_url_map.playInfo,{
              params : {
                  teamId: this.tid,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success){
                  //success
                this.$join_modal({
                    ua : self.ua,
                    id : self.tid,
                    playerData : {
                        "id": res.data.data.id,  //玩家ID
                        "account":res.data.data.account,  //玩家数字ID
                        "nick": res.data.data.nick,  //昵称
                        "corpId": res.data.data.corpId,  //军团ID
                        "corpName": res.data.data.corpName, //军团
                        "maxEquipScore": res.data.data.maxEquipScore  //历史最高神兵值
                    },
                });

              }
              else{            
                  this.$message.error(res.data.message);
              }
          });
      },         
    }
  };
</script>

<style scoped>

    .code-input{
        display: block;
        width: 400px;
        margin: 38px auto 105px;
        font-size: 24px;
        text-align: center;
    }

    .u-btn{
        display: block;
        width: 295px;
        height: 65px;
        margin: 0 auto;
        background-color: #820000;
        color: #fff;
        font-size: 24px;
    }  
</style>

<style>
    .code-input .el-input__inner{
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/codeModal/codeModal.vue